export type SystemTypeDetailsResult = {
  displayName: string;
  locale?: string;
};

export type SystemTypeResult = {
  id: number;
  systemTypeDetails: SystemTypeDetailsResult;
};

export type HelpUsDetailResult = {
  helpUsId: number;
  name: string;
  link: string;
  locale: string;
};

export type HelpUsTypeDetailResult = {
  helpUsTypeId: number;
  displayName: string;
  locale: string;
};

export type HelpUsTypeResult = {
  id: number;
  isActive: boolean;
  order?: number;
  helpUsTypeDetail: HelpUsTypeDetailResult;
};

export type HelpUsResult = {
  id: number;
  isActive: boolean;
  order?: number;
  systemTypeId: number;
  systemType: SystemTypeResult;
  helpUsTypeId: number;
  helpUsType: HelpUsTypeResult;
  helpUsDetail: HelpUsDetailResult;
};

export const HELP_US_TYPE_LINK = 1;
export const HELP_US_TYPE_PDF = 2;
